var map = {
	"./account_circle_black_24dp.svg": "vHS6",
	"./arrow_red.svg": "c/Dt",
	"./default_img.jpeg": "1bkw",
	"./file_upload_icon.svg": "Jzlv",
	"./help_outline_gray_24dp.svg": "b5FX",
	"./icon_directions_car.svg": "69rk",
	"./icon_document.svg": "QXeo",
	"./icon_hamburger.svg": "U5Yy",
	"./icon_handle.svg": "qD1+",
	"./icon_help.svg": "JSWz",
	"./icon_home.svg": "/4P6",
	"./icon_hub_bi.svg": "1ylu",
	"./icon_inventory.svg": "qPCm",
	"./icon_list_alt.svg": "atbb",
	"./icon_lock.svg": "6KeD",
	"./icon_menu_arrow_right.svg": "Zo3j",
	"./icon_menu_dashboard.svg": "RFp1",
	"./icon_menu_log.svg": "b6r/",
	"./icon_menu_manager.svg": "BlTb",
	"./icon_menu_setting.svg": "XdfT",
	"./icon_robot.svg": "pe6m",
	"./icon_shopping_mode.svg": "LpS0",
	"./icon_stacked_inbox.svg": "jdOp",
	"./icon_store.svg": "ceHe",
	"./icon_unlock_right.svg": "gDYA",
	"./loading.svg": "SE3R",
	"./loading_done.svg": "MVmW",
	"./login/left_retangles.svg": "nrrH",
	"./login/next-btn.svg": "g1Ky",
	"./login/previous-btn.svg": "T7Pd",
	"./login/right_retangles.svg": "sxJS",
	"./logo.png": "iQH9",
	"./logo/logo.svg": "qz/U",
	"./logo/logo_black.svg": "6C3a",
	"./robo-hi.png": "KJHV",
	"./setting-wizard/strict.svg": "fSFW",
	"./setting-wizard/task_detail_setting.svg": "1ubB",
	"./setting-wizard/task_detail_setting_2.svg": "06Yn",
	"./setting-wizard/task_detail_setting_3.svg": "FBUB",
	"./setting-wizard/wizard-tsort-1.svg": "5HpQ",
	"./setting-wizard/wizard-tsort-2.svg": "mPSH",
	"./setting-wizard/wizard-tsort-3.svg": "dZDe",
	"./strictness_data_uploading.svg": "jVd0",
	"./type-setting/bar_code.svg": "/17R",
	"./type-setting/box.svg": "/vh9",
	"./type-setting/box_xl.svg": "luKH",
	"./type-setting/collect_manual.svg": "3wb/",
	"./type-setting/error_case_1.svg": "0kYS",
	"./type-setting/error_case_2.svg": "06kO",
	"./type-setting/img_title_2.svg": "F0/W",
	"./type-setting/list.svg": "od2q",
	"./type-setting/order_sorting.svg": "Wd+y",
	"./type-setting/plan_1.svg": "KV/A",
	"./type-setting/plan_2.svg": "MFqm",
	"./type-setting/product_method_1.svg": "JoYj",
	"./type-setting/product_method_2.svg": "jPB5",
	"./type-setting/product_method_3.svg": "JjZN",
	"./type-setting/reject_1.svg": "fxeY",
	"./type-setting/reject_2.svg": "nuCE",
	"./type-setting/rule_sorting.svg": "P/JF",
	"./type-setting/scan_preview.svg": "C0WF",
	"./type-setting/shoot_sorting.svg": "9cTS",
	"./type-setting/slip_scan.svg": "d5lm",
	"./type-setting/task_type_setting.svg": "leL9",
	"./type-setting/upload_csv.svg": "7wgo",
	"./vector-tick.svg": "1DsQ",
	"./wizard_first.svg": "tgl6"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "g2Y0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*$
// module id = g2Y0
// module chunks = 1